import ScoreCardAnalyticValue from './ScoreCardAnalyticValue';

export default ScoreCardAnalyticValue;
